import React from 'react'

const CompanyContext = React.createContext()

export const CompanyProvider = CompanyContext.Provider
export const CompanyConsumer = CompanyContext.Consumer

export default CompanyContext